import React, { Component } from 'react';
import { has,map} from 'lodash';
import DriverEmergencyHeader from './DriverEmergencyHeader';
import DriverEmergencyRequestList from './DriverEmergencyRequestList';
import DriverEmergencyDisplayOnMap from './DriverEmergencyDisplayOnMap';



export default class DriverEmergencyHome extends Component {
    constructor(props) {
        super(props);
    }

    render() {
     const {authReducer, commonReducer,driveremergencyReducer} = this.props;

            return (
        <div>
        {/*<DriverEmergencyHeader/>*/}
            <div className="container-fluid">
              <div className="row clearfix">
              <DriverEmergencyHeader commonReducer={this.props.commonReducer} actions={this.props.actions} notificationCount={2} profileName="Derrick Frank" notificationCallBack={this.toggleNotification}
               router={this.props.router} displayName="Emergency Request" displayLogo="true" driveremergencyReducer={driveremergencyReducer}/>
               <DriverEmergencyRequestList {...this.props} actions={this.props.actions} />
               { driveremergencyReducer.driverAcceptFlag &&
               <DriverEmergencyDisplayOnMap {...this.props}   flowType='offlineFlag'/>
               }
              </div>
            </div>
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DriverEmergency/DriverEmergencyHome.jsx